export default "__VITE_ASSET__9d47aaeb__"